module.exports = __webpack_public_path__ + "static/img/wood_256.ea5fa77.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/wood_256.png
// module id = 8Pjb
// module chunks = 0